import { render, staticRenderFns } from "./language_test_details.vue?vue&type=template&id=1de47c6d&"
import script from "./language_test_details.vue?vue&type=script&lang=js&"
export * from "./language_test_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports